import React from 'react'
import { Provider, connect } from 'react-redux'
import AdLibraryHolder from './styles/adLibraryViewStyle'
import adLibraryStore from '../features/adLibrary/redux/store'
import AdLibraryContainer from '../features/adLibrary/containers/AdLibraryContainer'

// The feature owns an isolated Redux store, mounted here via its own <Provider>
// (nested inside the global app Provider but overriding it for this subtree).
//
// This component is connected to the GLOBAL store (the connect HOC sits above
// the nested Provider) only to bridge the logged-in user's id and role down into
// the isolated store — getClients(userId) needs the id, uploading a dynamic ad
// needs the role, and the isolated store has no auth state of its own.
//
// These reach AdLibraryComponent as ownProps: connect() merges them, so the
// container does not need to map them.
const AdLibraryView = ({ user, isSuperUser }) => (
  <Provider store={adLibraryStore}>
    <AdLibraryHolder>
      <AdLibraryContainer
        userId={user && user.id}
        companyId={user && user.company && user.company.id}
        companyType={user && user.company && user.company.type}
        isSuperUser={isSuperUser}
      />
    </AdLibraryHolder>
  </Provider>
)

const mapStateToProps = ({ userAccount }) => ({
  user: userAccount.user,
  // superAdmin || superModeratorAgency || superModeratorMediaCompany — the exact
  // trio the backend requires to create dynamic contents.
  isSuperUser: userAccount.isSuperUser,
})

export default connect(mapStateToProps)(AdLibraryView)
